/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Laps_Row_Shorter_HintInputs */

const en_ui_laps_row_shorter_hint = /** @type {(inputs: Ui_Laps_Row_Shorter_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a shorter split distance`)
};

const de_ui_laps_row_shorter_hint = /** @type {(inputs: Ui_Laps_Row_Shorter_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle eine kürzere Split-Distanz`)
};

/**
* | output |
* | --- |
* | "Choose a shorter split distance" |
*
* @param {Ui_Laps_Row_Shorter_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_laps_row_shorter_hint = /** @type {((inputs?: Ui_Laps_Row_Shorter_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Laps_Row_Shorter_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_laps_row_shorter_hint(inputs)
	return de_ui_laps_row_shorter_hint(inputs)
});